import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl';
import downloadIcon from "./img/download-icon.png";
import "./styles/LinksDownloadFormats.scss";
import { Query } from 'react-apollo';
import meQuery from 'utils/queries/MeQuery';
import { FORMATS_NAMES } from './constants';
import LoadingMessage from 'utils/components/LoadingMessage';

const LinksDownloadFormats = ({ authorizationFormats, loadingFormats }) => {
  const formatsOrFormat = authorizationFormats?.extractedFiles;

  const handleDownloadFormat = (url, userInstance, version) => {
    const link = document.createElement("a");
    link.href = url;

    // Determine the correct file name based on user instance
    if (version)
      link.setAttribute("download", `${FORMATS_NAMES[userInstance][version]}.docx`);
    else
      link.setAttribute("download", `${FORMATS_NAMES[userInstance]}.docx`);


    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return (
    <Query query={meQuery}>
      {({ loading, error, data }) => {
        if (loading || error) return null;

        const { me } = data;
        const { profile } = me || {};
        const { geographicInstance } = profile || {};

        // Extract the user instance
        const userInstance = geographicInstance.edges[0]?.node?.code;

        return !loadingFormats ? (
          <>
            <div className="col-12 d-lg-flex mt-4 gap-4">
              {formatsOrFormat && formatsOrFormat?.length > 1 ? (
                <>
                  <button
                    onClick={() =>
                      handleDownloadFormat(
                        formatsOrFormat[1].url,
                        userInstance,
                        1
                      )
                    }
                    className="step-0-form__submit-btn introduction-disclaimer__btn mb-2 mb-lg-0 px-lg-5 rounded-5"
                  >
                    <FormattedMessage
                      id="ProjectStepFormDisclaimer.button.downloadSpanishVersion"
                      defaultMessage="Descargar formato en español {icon}"
                      values={{
                        icon: (
                          <img
                            src={downloadIcon}
                            width={13}
                            height={13}
                            alt="download icon"
                            className="ml-1"
                          />
                        ),
                      }}
                    />
                  </button>
                  <button
                    onClick={() =>
                      handleDownloadFormat(
                        formatsOrFormat[0].url,
                        userInstance,
                        2
                      )
                    }
                    className="step-0-form__submit-btn introduction-disclaimer__btn px-lg-5 rounded-5"
                  >
                    <FormattedMessage
                      id="ProjectStepFormDisclaimer.button.downloadEnglishVersion"
                      defaultMessage="Descargar formato en inglés {icon}"
                      values={{
                        icon: (
                          <img
                            src={downloadIcon}
                            width={13}
                            height={13}
                            alt="download icon"
                            className="ml-1"
                          />
                        ),
                      }}
                    />
                  </button>
                </>
              ) : (
                <button
                  onClick={() =>
                    handleDownloadFormat(formatsOrFormat[0]?.url, userInstance)
                  }
                  className="step-0-form__submit-btn introduction-disclaimer__btn px-lg-5 rounded-5"
                >
                  <FormattedMessage
                    id="ProjectStepFormDisclaimer.button.downloadOnlyFormat"
                    defaultMessage="Descargar formato {icon}"
                    values={{
                      icon: (
                        <img
                          src={downloadIcon}
                          width={13}
                          height={13}
                          alt="download icon"
                          className="ml-1"
                        />
                      ),
                    }}
                  />
                </button>
              )}
            </div>
          </>
        ) : (
          <div key="loader" className="text-center col-12 pt-3">
            <LoadingMessage />
          </div>
        );
      }}
    </Query>
  );
}

export default LinksDownloadFormats